import React from 'react'

const CardWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="relative h-[305px] w-full hover:shadow-xl cursor-pointer">{children}</div>
)

export default CardWrapper
